var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9236 14.2679C16.2021 14.7489 15.3641 15.0032 14.5 15.0032C13.636 15.0032 12.7979 14.7489 12.0765 14.2679L0.193088 6.34545C0.127158 6.3015 0.0629277 6.25568 0 6.20855V19.1904C0 20.6788 1.20786 21.8601 2.66964 21.8601H26.3303C27.8187 21.8601 28.9999 20.6522 28.9999 19.1904V6.2085C28.9369 6.25573 28.8726 6.30167 28.8065 6.34568L16.9236 14.2679Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13564 4.93148L13.019 12.854C13.4689 13.1539 13.9844 13.3039 14.4999 13.3039C15.0155 13.3039 15.5311 13.1539 15.981 12.854L27.8644 4.93148C28.5755 4.45768 29 3.66471 29 2.80887C29 1.33729 27.8028 0.140137 26.3313 0.140137H2.66874C1.19721 0.140193 0 1.33735 0 2.81029C0 3.66471 0.424578 4.45768 1.13564 4.93148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/Icon-mail.87a873cc99ed1885ead42dffa967eb16.svg";
export { ForwardRef as ReactComponent };